import { render, staticRenderFns } from "./FeedsSubmissionForm.vue?vue&type=template&id=4602827c"
import script from "./FeedsSubmissionForm.vue?vue&type=script&lang=js"
export * from "./FeedsSubmissionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports